<div
  #editViewElement
  style="font-size: 16px"
  [attr.data-cy-editview-tablename]="editTabs[0]?.data.tableName"
  [attr.data-cy-editview-tablevel]="editTabs[0]?.data.tabLevel"
  [ngClass]="cssClass"
  [style.height.%]="100">
  @if (isZoomTarget) {
    <div
      class="iupics-blade-content-sidebar"
      [ngClass]="[GridViewVisibility === 'hidden' ? 'invisible' : 'visible']"
      [ngStyle]="{ visibility: GridViewVisibility }">
      <div class="iupics-blade-content-sidebar-content visible">
        <div class="p-toolbar ui-widget-header ui-corner-all ui-helper-clearfix">
          <div class="ui-right" (click)="GridViewVisibility = 'hidden'">
            <button
              class="p-button p-menu-bar-button p-button-icon-only"
              icon="icon-close"
              pButton
              type="button"
              [attr.aria-label]="'menuBarDetails.close' | translate">
              {{ '' }}
            </button>
          </div>
        </div>
        <iu-grid-view-ui
          #gridViewUi
          [DOMParentComponent]="container"
          [container]="container"
          [cssClass]="'iupics-blade-content-first'"
          [data]="zoomTargetData[0].data"
          [gridTabFilter]="filterZoomTarget"
          [hasUniversalFilter]="true"
          [isMenuDisplay]="true"
          [isZoomTargetGrid]="true"
          [tabId]="zoomTargetData[0].tabId"
          [windowType]="undefined"
          (gridTabAfterViewInitEmitter)="onZoomTargetGridAfterViewInit($event)"
          (gridViewCellClicked)="gridViewCellClicked($event)" />
      </div>
    </div>
  }

  <iu-menu-bar-detail-ui
    [activeTabID]="container?.activeTab?.id"
    [arrowsDisplayed]="
      linkedComponents && linkedComponents.length > 0 ? linkedComponents[0].children.length === 0 : false
    "
    [breadcrumb]="container.breadcrumbComponent"
    [changingMenuBar]="changingMenuBar"
    [datastorekey]="currentDataStoreKey"
    [isDeleteable]="isDeleteable"
    [isInsertRecord]="isInsertRecord"
    [isReadOnly]="isReadOnly"
    [isSplitView]="isSplitView"
    [isZoomEditView]="isZoomEditView"
    [isZoomTarget]="zoomTarget ? true : false"
    [linkedComponents]="linkedComponents"
    [nbRequest]="nbRequest"
    [justSaved]="justSaved"
    [saving]="isSaving"
    [nbUploadedFiles]="nbUploadedFiles"
    [noData]="noData"
    [processed]="
      editTabs[0] && editTabs[0].dataStored && editTabs[0].dataStored.data ? editTabs[0].dataStored.data.Processed : 'N'
    "
    [status]="editTabs[0] && editTabs[0].dataStored ? editTabs[0].dataStored.status : DatastoreStatus.SYNC"
    [tabId]="tabId"
    [viewRecordChangeLogLabel]="editTabs[0] ? editTabs[0]?.data.label : ('tabUi.loading' | translate)"
    [windowId]="data?.AD_Window_ID"
    (changeGridElementEvent)="changeGridElement($event)"
    (changeGridViewVisibility)="changeGridViewVisibility()"
    (closeEvent)="checkBeforeClose($event)"
    (copyEvent)="copyData($event)"
    (deleteEvent)="deleteData($event)"
    (emailEvent)="updateModalDisplay({ display: { key: 'displayEmailEditor', value: true } })"
    (exportDataEvent)="updateModalDisplay({ display: { key: 'displayExportDataModal', value: true } })"
    (joinFilesEvent)="updateModalDisplay({ display: { key: 'displayJoinFilesPanel', value: true } })"
    (newEvent)="openNew($event)"
    (noteEvent)="showNotes()"
    (printEvent)="printReport($event)"
    (processEvent)="showProcess($event)"
    (refreshEvent)="refreshData(true, $event)"
    (requestEvent)="showRequest()"
    (saveEvent)="beforeSave($event)"
    (viewRecordChangeLog)="viewRecordChangeLog()" />
  <!-- fixed slot: the bar appearing on each load pushed the form down -->
  <div class="ev-loading-slot">
    @if (isLoading) {
      <p-progressBar [mode]="'indeterminate'" [showValue]="false" [styleClass]="'loading-progressbar'" [value]="0" />
    }
  </div>

  <div class="compContainer">
    <div class="contentInline ev-column" style="font-size: 16px; word-break: break-all" [style.width]="cssWidth">
      <!-- info bar: processes (click menu), links of the record, additional information -->
      <div #infoBar class="iu-editview-info">
        @let tabProcs = tabProcesses();
        @if (tabProcs.length) {
          <div class="ev-menu">
            <button
              type="button"
              class="ev-menu-btn"
              data-menu="process"
              aria-haspopup="menu"
              [attr.aria-expanded]="menuOpen === 'process'"
              (click)="toggleMenu('process', $event)">
              <i aria-hidden="true" class="fas fa-cog"></i>
              <span>{{ 'editView.processes' | translate }}</span>
              <span class="ev-menu-count">{{ tabProcs.length }}</span>
              <i aria-hidden="true" class="fa-solid fa-chevron-down ev-menu-caret"></i>
            </button>
            @if (menuOpen === 'process') {
              <ul class="ev-menu-list" role="menu" (click)="$event.stopPropagation()" (keydown.escape)="closeMenu(true)">
                @for (process of tabProcs; track $index) {
                  <li role="none">
                    <button
                      type="button"
                      role="menuitem"
                      class="ev-menu-item"
                      [class.readonly]="process.readOnly"
                      [disabled]="process.readOnly"
                      [attr.aria-disabled]="process.readOnly"
                      [title]="process.readOnly ? ('editView.processReadOnly' | translate) : process.label"
                      (click)="closeMenu(); showProcess(process)">
                      <i aria-hidden="true" class="fas fa-cog"></i>
                      <span>{{ process.label }}</span>
                    </button>
                  </li>
                }
              </ul>
            }
          </div>
        }
        <iu-menu-smart-buttons-ui [tabId]="tabId" [windowId]="data?.AD_Window_ID" />
        <!-- status, document actions and the additional information button stay together: when the bar is too
             narrow they go to its second line as one group (the lone info icon looked lost) -->
        <div class="ev-right">
          <!-- status and document actions on the same bar (they took a line of their own); they go to a second
               line of the bar only when the blade is too narrow -->
          @if (isStepperVisible && editTabs[0]?.data?.isDocumentTab) {
            <div #stepperDiv class="ev-status">
              <iu-stepper-ui
                [changingStepper]="changingStepper"
                [data]="editTabs[0].data.stepperData"
                [editTab]="editTabs[0]"
                [isIndexNumber]="false"
                [isReadOnly]="isLoading"
                [parent]="this"
                [preventPrevious]="true"
                (refreshEdit)="refreshEditViews(false)" />
            </div>
          }
          @if (additionalInfoWidthExpanded) {
            <button
              type="button"
              class="ev-info-toggle"
              data-cy="additional-info-toggle"
              [class.ev-info-toggle--on]="isAdditionalOpened"
              [attr.aria-pressed]="!!isAdditionalOpened"
              [title]="(isAdditionalOpened ? 'editView.hideAdditionalInformation' : 'editView.additionalInformation') | translate"
              [attr.aria-label]="'editView.additionalInformation' | translate"
              (click)="toggleAdditional()">
              <i aria-hidden="true" class="fa-solid fa-circle-info"></i>
              <span class="ev-info-toggle-label">{{ 'editView.additionalInformation' | translate }}</span>
            </button>
          }
        </div>
      </div>
      @if (conflictsResult.refreshAuto) {
        <iu-banner type="success">
          {{ 'editView.refreshAutoMsg' | translate }}
        </iu-banner>
      } @else if (conflictsResult.mustRefresh) {
        <iu-banner icon="icon-refresh3x" type="warning">
          {{ 'editView.mustRefreshMsg' | translate }}
        </iu-banner>
      }
      @if (conflictsResult.hasConflicts) {
        <iu-banner type="error">
          {{ 'editView.hasConflictsMsg' | translate }}
          <button
            type="button"
            style="text-decoration: underline; cursor: pointer; background: none; border: 0; padding: 0; color: inherit; font: inherit"
            (click)="wantToMergeConflicts = true">
            {{ 'editView.verify' | translate }}
          </button>
          {{ 'editView.andSave' | translate }} <br />{{ nbConflicts }} {{ 'editView.remainingConflict' | translate }}
        </iu-banner>
      }
      <!-- sections of the record: where you are, a mark on groups with an empty mandatory field, jump to it -->
      @let sections = sectionItems();
      @if (sections.length > 1) {
        <div #sectionWrap class="ev-sections-wrap">
        <button
          type="button"
          class="ev-sections-arrow ev-sections-arrow--left"
          tabindex="-1"
          [attr.aria-label]="'generic.previous' | translate"
          (click)="scrollSections(-1)">
          <i aria-hidden="true" class="fa-solid fa-chevron-left"></i>
        </button>
        <nav #sectionNav class="ev-sections" [attr.aria-label]="'editView.sections' | translate">
          @for (s of sections; track s.key; let first = $first) {
            <button
              type="button"
              class="ev-section"
              [class.ev-section--on]="(activeSectionKey ?? sections[0].key) === s.key"
              [class.ev-section--todo]="s.todo"
              [class.ev-section--tab]="s.kind === 'tab'"
              [attr.aria-current]="(activeSectionKey ?? sections[0].key) === s.key ? 'location' : null"
              [attr.data-key]="s.key"
              [title]="s.todo ? ('editView.sectionMandatory' | translate) : s.label"
              (click)="goToSection(s, $event)">
              @if (s.todo) {
                <i aria-hidden="true" class="fa-solid fa-circle-exclamation"></i>
              } @else if (s.kind === 'tab') {
                <i aria-hidden="true" class="fa-solid fa-table-list"></i>
              }
              <span>{{ s.label }}</span>
            </button>
          }
        </nav>
        <button
          type="button"
          class="ev-sections-arrow ev-sections-arrow--right"
          tabindex="-1"
          [attr.aria-label]="'generic.next' | translate"
          (click)="scrollSections(1)">
          <i aria-hidden="true" class="fa-solid fa-chevron-right"></i>
        </button>
        </div>
      }
      <!-- the only scrolling part: bars above stay in place -->
      <div class="ev-scroll">
        <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
          <div #gridUi class="p-col contentInlineScrollPanel blade-grid" id="{{ scrollPanelid }}">
            <ng-template iuDynamicContainer />
          </div>
        </p-scrollPanel>
      </div>
    </div>
    <div class="contentInline2" [class.ev-additional-closed]="additionalInfoWidthExpanded && !isAdditionalOpened">
      @if (additionalInfoWidthExpanded) {
        <article #article class="accordion" style="position: relative" [style.height.%]="100">
          <section
            id="acc1"
            [ngClass]="[!isAdditionalOpened ? 'additionalHidden' : '']"
            [style.height.%]="100"
            [style.width]="additionalInfoWidth">
            <h2>
              <a
                #openButton
                href="#"
                role="button"
                [attr.aria-expanded]="!!isAdditionalOpened"
                (click)="$event.preventDefault(); isAdditionalOpened ? minimize() : resize()">
                <i aria-hidden="true" class="icon-up"></i>
                <span>{{ 'editView.additionalInformation' | translate }}</span>
              </a>
            </h2>
            <p-scrollPanel [style]="{ width: '100%', height: '100%' }">
              <ng-container #additionalInfoVcr />
            </p-scrollPanel>
          </section>
        </article>
      }
    </div>
    <div
      #sideBladeContainer
      class="side-blade-wraper"
      tabindex="-1"
      [attr.data-expanded]="sideComponentRef !== null"
      (keydown)="onSideBladeKeydown($event)">
      @if (sideComponentRef) {
        <div class="side-blade-header-content">
          <div class="side-blade-title">
            <i aria-hidden="true" [class]="sideBladeIconClass"></i>
            <span class="title" tooltipPosition="bottom" pTooltip="{{ sideBladeTitle }}">{{ sideBladeTitle }}</span>
          </div>
          <div class="side-blade-buttons">
            @if (sidePreview && previewFiles.length > 1) {
              <div class="side-blade-nav">
                <button
                  class="side-blade-action"
                  data-cy="side-blade-previous"
                  tooltipPosition="bottom"
                  type="button"
                  [attr.aria-label]="'generic.previous' | translate"
                  [disabled]="previewIndex <= 0"
                  [pTooltip]="'generic.previous' | translate"
                  (click)="previewNavigate(-1)">
                  <i aria-hidden="true" class="icon-back"></i>
                </button>
                <span class="side-blade-position" data-cy="side-blade-position">
                  {{ previewIndex + 1 }} / {{ previewFiles.length }}
                </span>
                <button
                  class="side-blade-action"
                  data-cy="side-blade-next"
                  tooltipPosition="bottom"
                  type="button"
                  [attr.aria-label]="'generic.next' | translate"
                  [disabled]="previewIndex >= previewFiles.length - 1"
                  [pTooltip]="'generic.next' | translate"
                  (click)="previewNavigate(1)">
                  <i aria-hidden="true" class="icon-next"></i>
                </button>
              </div>
            }
            @if (sidePreview?.canDownload) {
              <button
                class="side-blade-action"
                data-cy="side-blade-download"
                tooltipPosition="bottom"
                type="button"
                [attr.aria-label]="'generic.download' | translate"
                [pTooltip]="'generic.download' | translate"
                (click)="downloadSidePreview()">
                <i aria-hidden="true" class="icon-download"></i>
              </button>
            }
            @if (sidePreview?.canOpenInNewTab) {
              <button
                class="side-blade-action"
                data-cy="side-blade-open-new-tab"
                tooltipPosition="bottom"
                type="button"
                [attr.aria-label]="'previewDoc.openInNewTab' | translate"
                [pTooltip]="'previewDoc.openInNewTab' | translate"
                (click)="openSidePreviewInNewTab()">
                <i aria-hidden="true" class="icon-external-links"></i>
              </button>
            }
            <button
              class="side-blade-action"
              data-cy="side-blade-open-floating"
              tooltipPosition="bottom"
              type="button"
              [attr.aria-label]="'generic.openFileInFloatingPanel' | translate"
              [pTooltip]="'generic.openFileInFloatingPanel' | translate"
              (click)="openInDraggableWindow()">
              <i aria-hidden="true" class="fa fa-window-restore"></i>
            </button>
            <button
              class="side-blade-action side-blade-close"
              data-cy="side-blade-close"
              tooltipPosition="bottom"
              type="button"
              [attr.aria-label]="'generic.close' | translate"
              [pTooltip]="'generic.close' | translate"
              (click)="closeSideBarAndBlade()">
              <i aria-hidden="true" class="icon-close"></i>
            </button>
          </div>
        </div>
      }
      <div class="side-blade-content" [ngClass]="[sideComponentRef ? 'side-blade-content-shown' : '']">
        <ng-container #sideBladeVcr />
      </div>
      @if (sideComponentRef) {
        <div
          class="resizable-handle"
          role="separator"
          aria-orientation="vertical"
          [attr.aria-label]="'previewDoc.resize' | translate"
          [title]="'previewDoc.resize' | translate"
          (mousedown)="startResizeSideBlade($event)"
          (touchstart)="startResizeSideBlade($event)">
          <i aria-hidden="true" class="icon-grab"></i>
        </div>
      }
    </div>
  </div>
</div>

@if (wantToMergeConflicts) {
  <div class="modal-background">
    <iu-mergetool [conflictsResult]="conflictsResult" [parentEditView]="this" (mergeEmitter)="onMerge($event)"
      (cancelEmitter)="wantToMergeConflicts = false" />
  </div>
}

<p-sidebar
  #sideBar
  position="right"
  styleClass="p-sidebar-md "
  [baseZIndex]="0"
  [dismissible]="false"
  [(visible)]="isSidebarOpen"
  (onHide)="closeSideBarAndBlade()">
  <ng-container #sideBarVcr />
</p-sidebar>
<!-- #region audit panel -->
@if (showAuditsPanel) {
  <iu-modal-ui
    [modalClass]="'iu-changelog-modal'"
    [title]="'editView.registeredInformation' | translate"
    (closeModalEmitter)="showAuditsPanel = false">
    <ng-template #vcrAudit />
  </iu-modal-ui>
}
<!-- #endregion -->

@if (displayJoinFilesPanel) {
  <iu-modal-ui
    [contentType]="ModalContentType.JOINFILES"
    [hasCloseBtn]="true"
    [title]="'joinFiles.title'"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayJoinFilesPanel', value: false } })">
    <iu-join-file-ui
      [adTab_ID]="tabId"
      [adTable_ID]="table_id"
      [data]="data"
      [dsKey]="currentDataStoreKey"
      [(nbUploadedFiles)]="nbUploadedFiles"
      (openFileOnSideEmitter)="showPreview($event)" />
  </iu-modal-ui>
}
@if (displayEmailEditor) {
  <iu-modal-ui
    [modalClass]="'iu-email-editor-modal'"
    [title]="'email.title'"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayEmailEditor', value: false } })">
    <iu-email-editor-ui
      [parentEditView]="this"
      (cancelEmailEmitter)="updateModalDisplay({ display: { key: 'displayEmailEditor', value: false } })" />
  </iu-modal-ui>
}
@if (displayExportDataModal) {
  <iu-modal-ui
    #exportDataModal
    [angularStyle]="{ 'iu-modal-body': { overflow: 'unset' } }"
    [title]="'exportData.title'"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayExportDataModal', value: false } })">
    <iu-export-data-ui
      [dsKey]="currentDataStoreKey"
      [sourceModal]="exportDataModal"
      [tabId]="tabId"
      [tableId]="editTabs[0].data.AD_Table_ID"
      (afterExecute)="updateNbFileAttached()"
      (cancelExportDataEmitter)="updateModalDisplay({ display: { key: 'displayExportDataModal', value: false } })" />
  </iu-modal-ui>
}
@if (displayProcessUI) {
  <iu-modal-ui
    [angularStyle]="{ 'iu-modal-body': { padding: 0 } }"
    [contentType]="ModalContentType.PROCESS"
    [hasCloseBtn]="false"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayProcessUI', value: false } })">
    <iu-process-ui
      [isModal]="true"
      [parentComponent]="this"
      [sourceComponentData]="displayProcessUI_sourceComponentData"
      [windowId]="processId"
      (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayProcessUI', value: false } })" />
  </iu-modal-ui>
}
<div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
  <iu-modal-ui
    #specificModal
    [angularStyle]="customFormModalBodyCss"
    [contentType]="ModalContentType.FORM"
    [isModalDisplay]="displayFormUI"
    [modalClass]="modalClass"
    [title]="specificWindowTitle"
    (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false } })">
    <ng-template #vcrSpecific />
  </iu-modal-ui>
</div>
